<template>
	<div class="SearchFilterContainer">
		<slot></slot>
	</div>
</template>

<style lang="scss" src="./SearchFilterContainer.scss"></style>
